<div class="calsium-panel">
  <table [class]="listClasses" [ngClass]="{loading: isLoading}">
    @if (listConfig.ShowListCaption) {
      <caption>
        <div style="float: left;" class="caption">
          {{listConfig.ListCaption}}&nbsp;&nbsp;(<span id="totalRowCount">{{getTotalResultCount()}}</span>)
        </div>
        <div class="d-inline-flex float-right">
          @if (listConfig.ShowClearFilterSortingButton) {
            <button class="btn btn-sm btn-default"
              id="clearFilterAndSorting" (click)="clearFilterAndSorting()">
              <i class="fas fa-lg fa-trash-alt"></i>&nbsp; {{resources.ClearFilterAndSort}}
            </button>
          }
          @if (listConfig.ShowPrint) {
            <button class="btn btn-sm btn-default" id="print" (click)="print()">
              <i class="fas fa-lg fa-print"></i>&nbsp; {{resources.Print}}
            </button>
          }
          <!-- Your grid row or cell  and in accept we can restrict files-->
          <div class="d-flex gap-4">
            @if (listConfig.ShowImportButton) {
              <div>
                <button class="btn btn-sm btn-default"
                (click)="fileInput.click()">Import Price List</button>
                <input #fileInput type="file"
                  [accept]="acceptedExcelFileTypes.join(', ')"
                  style="display:none" (change)="onFileSelected($event)"/>
                </div>
              }
              @if (listConfig.ShowExportToExcel) {
                <button class="btn btn-sm btn-default" id="exportToExcel"
                  (click)="exportToExcel()" [disabled]="exportButtonState">
                  <i class="fas fa-lg fa-file-excel"></i>&nbsp; {{resources.ExportToExcel}}
                </button>
              }
            </div>
          </div>
        </caption>
      }

      <thead class="thead-dark">
        <!-- COLUMNS HEADERS ROW -->
        <tr>
          @if (listConfig.HasSubComponent) {
            <th></th>
          }
          @for (column of listConfig.ListColumns; track column) {
            @if (column.IsVisible | async) {
              <th [class]="(column.TextAlignment || '')">
                <!-- COLUMNS HEADERS -->
                @if (column.Caption) {
                  <div style="white-space: nowrap" [title]="column.Tooltip">
                    {{column.Caption}}
                  </div>
                }
                @if (column.DynamicCaption) {
                  <div style="white-space: nowrap" [title]="column.Tooltip">
                    {{column.DynamicCaption | async}}
                  </div>
                }
              </th>
            }
          }
          @if (listConfig.AllowEdit || listConfig.AllowDelete || listConfig.AllowAdd || listConfig.ActionsButttons.length) {
            <th
              >
              &nbsp;
            </th>
          }
        </tr>

        <!-- FILTER FIELDS ROW -->
        @if (listConfig.ShowFilterRow) {
          <tr class="filter-row" style="white-space: nowrap">
            @if (listConfig.HasSubComponent) {
              <td></td>
            }
            @for (column of listConfig.ListColumns; track column) {
              @if (column.IsVisible | async) {
                <td>
                  <div class="input-group input-group-sm {{column.DataType}}-parent-div">
                    <!-- FILTER INPUT -->
                    @if (column.DataType=='selector' && showSelectAllCheckBox()) {
                      <mat-checkbox (change)="selectAll($event)" [checked]="column.SelectorValue">
                      </mat-checkbox>
                    }
                    @if (column.AllowFilter && (column.DataType=='string' || column.DataType=='anchor')) {
                      <input type="text" [(ngModel)]="column.FilterValue" (keyup.enter)="filterItems(column)"
                        [placeholder]="resources.TypeToFilter" class="form-control"
                        id="{{getSafeId('filter' + name + column.ColumnName)}}">
                      }
                      @if (column.AllowFilter && (column.DataType=='number')) {
                        <input type="number" [(ngModel)]="column.FilterValue"
                          (keyup.enter)="filterItems(column)" [placeholder]="resources.TypeToFilter"
                          class="form-control" id="{{getSafeId('filter' + name + column.ColumnName)}}">
                        }
                        @if (column.AllowFilter && column.DataType=='boolean') {
                          <select [(ngModel)]="column.FilterValue" (ngModelChange)="filterItems(column)"
                            class="form-control" id="{{getSafeId('filter'+ name + column.ColumnName)}}">
                            <option disabled="disabled" selected>{{resources.SelectToFilter}}</option>
                            <option value="">*{{resources.All}}*</option>
                            <option value="true">
                              {{column.FilterBooleanTrueText || resources.Yes}}
                            </option>
                            <option value="false">
                              {{column.FilterBooleanFalseText || resources.No}}
                            </option>
                          </select>
                        }
                        @if (column.AllowFilter && column.DataType=='date') {
                          <input type="date" [(ngModel)]="column.FilterValue"
                            (ngModelChange)="filterItems(column)" [placeholder]="resources.TypeToFilter"
                            class="form-control" id="{{getSafeId('filter' + name + column.ColumnName)}}"
                            pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}" max="9999-12-31">
                          }
                          @if (column.AllowFilter && column.DataType=='list') {
                            <select [(ngModel)]="column.FilterValue" (ngModelChange)="filterItems(column)"
                              class="form-control" id="{{getSafeId('filter'+ name + column.ColumnName)}}">
                              <option disabled="disabled" selected>{{resources.SelectToFilter}}</option>
                              <option value="">*{{resources['All']}}*</option>
                              @if (column.FilterOptions.AddEmptyDropDownListItem) {
                                <option value="null">
                                  *{{resources.Empty}}*
                                </option>
                              }
                              @for (subItem of column.FilterOptions.FilterListItems | async; track subItem) {
                                <option value="{{subItem.Value}}"
                                  >
                                  {{subItem.Text}}
                                </option>
                              }
                            </select>
                          }
                          <!-- SORT BUTTON -->
                          @if (column.Sortable) {
                            <div class="input-group-append" [ngClass]="column.AllowFilter ? '' : 'no-filter'">
                              <button class="btn btn-sm btn-info" id="sortDropdown" type="button"
                                data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <span class="{{getSortIconClass(column)}}"></span>
                              </button>
                              <div class="dropdown-menu">
                                <a class="dropdown-item" (click)="sortBy(column, 1)">
                                  <span class="fa fa-sort-amount-down-alt"></span> {{resources.Ascending}}
                                </a>
                                <a class="dropdown-item" (click)="sortBy(column, -1)">
                                  <span class="fa fa-sort-amount-down"></span> {{resources.Descending}}
                                </a>
                              </div>
                            </div>
                          }
                        </div>
                      </td>
                    }
                  }
                  @if (listConfig.AllowEdit || listConfig.AllowDelete || listConfig.AllowAdd || listConfig.ActionsButttons.length) {
                    <td
                      >
                    &nbsp;</td>
                  }
                </tr>
              }
            </thead>
            <tbody>
              <!-- DATA ROW -->
              @for (item of filteredList; track rowTrackById(item); let i = $index) {
                <tr app-calsiumlist-row [listConfig]="listConfig" [RowData]="item" [RowNumber]="i" [AddForm]="addForm"
                  [EditForm]="editForm" (id)="'row' + i" [selected]="isSelected(item)"
                [ngStyle]="listConfig.getSpeicalRowStyle(item)" appGlowElementOnFoucs></tr>
                @if (listConfig.HasSubComponent) {
                  @if (toggleSubContent === i) {
                    <tr (id)="'subContent' + i">
                      <td [attr.colspan]="listConfig.ListColumns.length + 1" style="background-color:wheat;">
                        <app-calsiumlist-sublist [inputComponent]="listConfig.SubComponent" [listComponent]="this">
                        </app-calsiumlist-sublist>
                      </td>
                    </tr>
                  }
                }
              }
              <!-- New Item Row-->
              @if (listConfig.AllowAdd) {
                <tr app-calsiumlist-row [listConfig]="listConfig" [RowNumber]="filteredList.length + 1"
                  [IsAddMode]="true" [AddForm]="addForm" (id)="'row' + filteredList.length + 1" appGlowElementOnFoucs>
                </tr>
              }

              <!--         <tr *ngIf="listConfig.AllowAdd ">
              <td *ngIf="listConfig.HasSubComponent"></td>
              <td *ngFor="let column of listConfig.ListColumns">
                <app-calsiumlist-cell CurrentMode="AddMode" [Column]="column" [RowNumber]="i" [AddForm]="addForm" [EditForm]="editForm"></app-calsiumlist-cell>
              </td>
              <td *ngIf="listConfig.AllowEdit || listConfig.AllowDelete || listConfig.AllowAdd">
                <button *ngIf="listConfig.AllowAdd" (click)="AddItem(addNewItemForm)">
                  <i *ngIf="listConfig.AllowAdd" class="fas fa-save"></i>
                </button>
              </td>
            </tr> -->
            <!-- SUM ROW -->
            @if (listConfig.ShowSumRow) {
              <tr>
                @if (listConfig.HasSubComponent) {
                  <th></th>
                }
                @for (column of listConfig.ListColumns ; track column) {
                  <th style="white-space: nowrap">
                    @if (column.IsCurrency) {
                      <span>{{getSum(column)}} SEK</span>
                    }
                    @if (!column.IsCurrency) {
                      <span>{{getSum(column)}}</span>
                    }
                  </th>
                }
              </tr>
            }
          </tbody>

          <!-- TABLE FOOTER -->
          @if (listConfig.ShowFooter ) {
            <tfoot>
              <tr>
                @if (listConfig.HasSubComponent) {
                  <td></td>
                }
                <td [attr.colspan]="listConfig.ListColumns.length ">
                  @for (item of listConfig.ListFooterData ; track item) {
                    <div class="col-md-12 "
                      style="border-bottom: 1px lightgrey solid ">
                      <div class="col-md-2 ">
                        <strong>{{item.Label}}</strong> :
                      </div>
                      <div class="col-md-10 ">{{item.Text}}</div>
                    </div>
                  }
                </td>
              </tr>
            </tfoot>
          }
        </table>
      </div>
